import {
  React,
  Component
} from 'imports/CommonImports';

class Forbidden extends Component {

  render() {
    return (
      <div>
        <h1>Uuuuuups!</h1>
        <h2>No tienes permisos para acceder a este sitio</h2>
      </div>
    );
  }
}

export default Forbidden;



// WEBPACK FOOTER //
// ./src/components/common/Forbidden.js